import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';

export type UsePostDXEmailFormData = {
    code: string;
    email: string;
};

export type UseSubmitEmailErrorResponse = Api.Response.Failure<'message'>;

export type UseSubmitEmailSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export const usePostDXEmail = (): UseMutationResult<
    UseSubmitEmailSuccessResponse,
    UseSubmitEmailErrorResponse,
    UsePostDXEmailFormData
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({code, email}: UsePostDXEmailFormData) =>
            request({
                formData: {email},
                locale,
                method: 'POST',
                uri: `/dx/${code}/submit/`,
            }),
    });
};
